// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AreaOfExpertise, CustomerAdminDetailAddress, CareerLevel, Gender, PushFrequency, CustomerAdminDetailForm } from "../schema";

export function serialize_CustomerAdminDetailForm(obj: CustomerAdminDetailForm): string {
  const serialized = ((value: {
    areaOfExpertise: AreaOfExpertise | null;
    batchEmails: boolean;
    billingAddress: CustomerAdminDetailAddress;
    careerLevel: CareerLevel | null;
    changePassword: boolean;
    commentNotification: boolean;
    customGender: string | null;
    customerId: number;
    education: boolean;
    email: string;
    gender: Gender | null;
    htmlEmail: boolean;
    invoiceByPost: boolean;
    language: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr";
    mailAddress: CustomerAdminDetailAddress;
    password: string;
    pushFrequency: PushFrequency;
    receiveNewsletters: boolean;
    unlimitedAccess: boolean;
    yearOfBirth: number | null;
  }): unknown => {
    return {
      areaOfExpertise: ((
        value:
          | (
              | "ACCOUNTING_AND_FINANCE"
              | "ADMINISTRATION"
              | "BUSINESS_DEVELOPMENT"
              | "COMMUNICATIONS"
              | "CUSTOMER_SERVICE"
              | "HUMAN_RESOURCES"
              | "INFORMATION_TECHNOLOGY"
              | "LEGAL"
              | "MARKETING"
              | "OPERATIONS"
              | "PRODUCTION"
              | "SALES"
              | "SUPPLY_MANAGEMENT"
              | "OTHER"
              | "UNDEFINED"
            )
          | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["areaOfExpertise"]),
      batchEmails: ((value: boolean): unknown => {
        return value;
      })(value["batchEmails"]),
      billingAddress: ((value: {
        address1: string | null;
        address2: string | null;
        addressId: number;
        company: string | null;
        countryCode: string | null;
        department: string | null;
        firstName: string | null;
        lastName: string | null;
        phone: string | null;
        position: string | null;
        state: string | null;
        title: number;
        town: string | null;
        vat: string | null;
        zipCode: string | null;
      }): unknown => {
        return {
          address1: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["address1"]),
          address2: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["address2"]),
          addressId: ((value: number): unknown => {
            return value;
          })(value["addressId"]),
          company: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["company"]),
          countryCode: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["countryCode"]),
          department: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["department"]),
          firstName: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["firstName"]),
          lastName: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["lastName"]),
          phone: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["phone"]),
          position: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["position"]),
          state: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["state"]),
          title: ((value: number): unknown => {
            return value;
          })(value["title"]),
          town: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["town"]),
          vat: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["vat"]),
          zipCode: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["zipCode"]),
        };
      })(value["billingAddress"]),
      careerLevel: ((
        value:
          | (
              | "OWNER_EXECUTIVE_C_LEVEL"
              | "SENIOR_MANAGEMENT"
              | "MIDDLE_MANAGEMENT"
              | "JUNIOR_MANAGEMENT"
              | "ADMINISTRATIVE_STAFF"
              | "EMPLOYEE_WITHOUT_MANAGEMENT_OR_LEADERSHIP_RESPONSIBILITY"
              | "STUDENT_OR_TRAINEE"
              | "TEACHER_OR_ACADEMIC"
              | "NOT_EMPLOYED"
              | "RETIRED"
              | "OTHER"
              | "UNDEFINED"
            )
          | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["careerLevel"]),
      changePassword: ((value: boolean): unknown => {
        return value;
      })(value["changePassword"]),
      commentNotification: ((value: boolean): unknown => {
        return value;
      })(value["commentNotification"]),
      customGender: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["customGender"]),
      customerId: ((value: number): unknown => {
        return value;
      })(value["customerId"]),
      education: ((value: boolean): unknown => {
        return value;
      })(value["education"]),
      email: ((value: string): unknown => {
        return value;
      })(value["email"]),
      gender: ((value: ("FEMALE" | "MALE" | "UNKNOWN" | "CUSTOM") | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["gender"]),
      htmlEmail: ((value: boolean): unknown => {
        return value;
      })(value["htmlEmail"]),
      invoiceByPost: ((value: boolean): unknown => {
        return value;
      })(value["invoiceByPost"]),
      language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
        return value;
      })(value["language"]),
      mailAddress: ((value: {
        address1: string | null;
        address2: string | null;
        addressId: number;
        company: string | null;
        countryCode: string | null;
        department: string | null;
        firstName: string | null;
        lastName: string | null;
        phone: string | null;
        position: string | null;
        state: string | null;
        title: number;
        town: string | null;
        vat: string | null;
        zipCode: string | null;
      }): unknown => {
        return {
          address1: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["address1"]),
          address2: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["address2"]),
          addressId: ((value: number): unknown => {
            return value;
          })(value["addressId"]),
          company: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["company"]),
          countryCode: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["countryCode"]),
          department: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["department"]),
          firstName: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["firstName"]),
          lastName: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["lastName"]),
          phone: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["phone"]),
          position: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["position"]),
          state: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["state"]),
          title: ((value: number): unknown => {
            return value;
          })(value["title"]),
          town: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["town"]),
          vat: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["vat"]),
          zipCode: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["zipCode"]),
        };
      })(value["mailAddress"]),
      password: ((value: string): unknown => {
        return value;
      })(value["password"]),
      pushFrequency: ((value: "NONE" | "DAILY" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"): unknown => {
        return value;
      })(value["pushFrequency"]),
      receiveNewsletters: ((value: boolean): unknown => {
        return value;
      })(value["receiveNewsletters"]),
      unlimitedAccess: ((value: boolean): unknown => {
        return value;
      })(value["unlimitedAccess"]),
      yearOfBirth: ((value: number | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["yearOfBirth"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_CustomerAdminDetailForm(str: string): ParserResult<CustomerAdminDetailForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    areaOfExpertise: AreaOfExpertise | null;
    batchEmails: boolean;
    billingAddress: CustomerAdminDetailAddress;
    careerLevel: CareerLevel | null;
    changePassword: boolean;
    commentNotification: boolean;
    customGender: string | null;
    customerId: number;
    education: boolean;
    email: string;
    gender: Gender | null;
    htmlEmail: boolean;
    invoiceByPost: boolean;
    language: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr";
    mailAddress: CustomerAdminDetailAddress;
    password: string;
    pushFrequency: PushFrequency;
    receiveNewsletters: boolean;
    unlimitedAccess: boolean;
    yearOfBirth: number | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "areaOfExpertise")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/areaOfExpertise]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'areaOfExpertise'.` };
    }
    const parsed_areaOfExpertise = ((): ParserResult<AreaOfExpertise | null> => {
      return ((value: unknown): ParserResult<AreaOfExpertise | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return ((
          value: unknown,
        ): ParserResult<
          | "ACCOUNTING_AND_FINANCE"
          | "ADMINISTRATION"
          | "BUSINESS_DEVELOPMENT"
          | "COMMUNICATIONS"
          | "CUSTOMER_SERVICE"
          | "HUMAN_RESOURCES"
          | "INFORMATION_TECHNOLOGY"
          | "LEGAL"
          | "MARKETING"
          | "OPERATIONS"
          | "PRODUCTION"
          | "SALES"
          | "SUPPLY_MANAGEMENT"
          | "OTHER"
          | "UNDEFINED"
        > => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/AreaOfExpertise]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "ACCOUNTING_AND_FINANCE":
              return { success: true, value: "ACCOUNTING_AND_FINANCE" };
            case "ADMINISTRATION":
              return { success: true, value: "ADMINISTRATION" };
            case "BUSINESS_DEVELOPMENT":
              return { success: true, value: "BUSINESS_DEVELOPMENT" };
            case "COMMUNICATIONS":
              return { success: true, value: "COMMUNICATIONS" };
            case "CUSTOMER_SERVICE":
              return { success: true, value: "CUSTOMER_SERVICE" };
            case "HUMAN_RESOURCES":
              return { success: true, value: "HUMAN_RESOURCES" };
            case "INFORMATION_TECHNOLOGY":
              return { success: true, value: "INFORMATION_TECHNOLOGY" };
            case "LEGAL":
              return { success: true, value: "LEGAL" };
            case "MARKETING":
              return { success: true, value: "MARKETING" };
            case "OPERATIONS":
              return { success: true, value: "OPERATIONS" };
            case "PRODUCTION":
              return { success: true, value: "PRODUCTION" };
            case "SALES":
              return { success: true, value: "SALES" };
            case "SUPPLY_MANAGEMENT":
              return { success: true, value: "SUPPLY_MANAGEMENT" };
            case "OTHER":
              return { success: true, value: "OTHER" };
            case "UNDEFINED":
              return { success: true, value: "UNDEFINED" };
            default:
              return {
                success: false,
                reason: `[#/components/schemas/AreaOfExpertise]: '${value}' expected to be enum, one of 'ACCOUNTING_AND_FINANCE, ADMINISTRATION, BUSINESS_DEVELOPMENT, COMMUNICATIONS, CUSTOMER_SERVICE, HUMAN_RESOURCES, INFORMATION_TECHNOLOGY, LEGAL, MARKETING, OPERATIONS, PRODUCTION, SALES, SUPPLY_MANAGEMENT, OTHER, UNDEFINED'.`,
              };
          }
        })(value);
      })(value["areaOfExpertise"]);
    })();
    if (!parsed_areaOfExpertise.success) {
      return { success: false, reason: parsed_areaOfExpertise.reason };
    }
    if (!hasProp(value, "batchEmails")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/batchEmails]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'batchEmails'.` };
    }
    const parsed_batchEmails = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/batchEmails]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["batchEmails"]);
    })();
    if (!parsed_batchEmails.success) {
      return { success: false, reason: parsed_batchEmails.reason };
    }
    if (!hasProp(value, "billingAddress")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/billingAddress]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'billingAddress'.` };
    }
    const parsed_billingAddress = ((): ParserResult<CustomerAdminDetailAddress> => {
      return ((value: unknown): ParserResult<CustomerAdminDetailAddress> => {
        return ((
          value: unknown,
        ): ParserResult<{
          address1: string | null;
          address2: string | null;
          addressId: number;
          company: string | null;
          countryCode: string | null;
          department: string | null;
          firstName: string | null;
          lastName: string | null;
          phone: string | null;
          position: string | null;
          state: string | null;
          title: number;
          town: string | null;
          vat: string | null;
          zipCode: string | null;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "address1")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/address1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'address1'.` };
          }
          const parsed_address1 = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/address1]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["address1"]);
          })();
          if (!parsed_address1.success) {
            return { success: false, reason: parsed_address1.reason };
          }
          if (!hasProp(value, "address2")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/address2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'address2'.` };
          }
          const parsed_address2 = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/address2]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["address2"]);
          })();
          if (!parsed_address2.success) {
            return { success: false, reason: parsed_address2.reason };
          }
          if (!hasProp(value, "addressId")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/addressId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'addressId'.` };
          }
          const parsed_addressId = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/addressId]: '${value}' expected to be of type number.` };
            })(value["addressId"]);
          })();
          if (!parsed_addressId.success) {
            return { success: false, reason: parsed_addressId.reason };
          }
          if (!hasProp(value, "company")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/company]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'company'.` };
          }
          const parsed_company = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/company]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["company"]);
          })();
          if (!parsed_company.success) {
            return { success: false, reason: parsed_company.reason };
          }
          if (!hasProp(value, "countryCode")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/countryCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryCode'.` };
          }
          const parsed_countryCode = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/countryCode]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["countryCode"]);
          })();
          if (!parsed_countryCode.success) {
            return { success: false, reason: parsed_countryCode.reason };
          }
          if (!hasProp(value, "department")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/department]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'department'.` };
          }
          const parsed_department = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/department]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["department"]);
          })();
          if (!parsed_department.success) {
            return { success: false, reason: parsed_department.reason };
          }
          if (!hasProp(value, "firstName")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
          }
          const parsed_firstName = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/firstName]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["firstName"]);
          })();
          if (!parsed_firstName.success) {
            return { success: false, reason: parsed_firstName.reason };
          }
          if (!hasProp(value, "lastName")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
          }
          const parsed_lastName = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/lastName]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["lastName"]);
          })();
          if (!parsed_lastName.success) {
            return { success: false, reason: parsed_lastName.reason };
          }
          if (!hasProp(value, "phone")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/phone]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'phone'.` };
          }
          const parsed_phone = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/phone]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["phone"]);
          })();
          if (!parsed_phone.success) {
            return { success: false, reason: parsed_phone.reason };
          }
          if (!hasProp(value, "position")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/position]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'position'.` };
          }
          const parsed_position = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/position]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["position"]);
          })();
          if (!parsed_position.success) {
            return { success: false, reason: parsed_position.reason };
          }
          if (!hasProp(value, "state")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/state]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'state'.` };
          }
          const parsed_state = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/state]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["state"]);
          })();
          if (!parsed_state.success) {
            return { success: false, reason: parsed_state.reason };
          }
          if (!hasProp(value, "title")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
          }
          const parsed_title = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/title]: '${value}' expected to be of type number.` };
            })(value["title"]);
          })();
          if (!parsed_title.success) {
            return { success: false, reason: parsed_title.reason };
          }
          if (!hasProp(value, "town")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/town]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'town'.` };
          }
          const parsed_town = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/town]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["town"]);
          })();
          if (!parsed_town.success) {
            return { success: false, reason: parsed_town.reason };
          }
          if (!hasProp(value, "vat")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/vat]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'vat'.` };
          }
          const parsed_vat = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/vat]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["vat"]);
          })();
          if (!parsed_vat.success) {
            return { success: false, reason: parsed_vat.reason };
          }
          if (!hasProp(value, "zipCode")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/zipCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'zipCode'.` };
          }
          const parsed_zipCode = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/zipCode]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["zipCode"]);
          })();
          if (!parsed_zipCode.success) {
            return { success: false, reason: parsed_zipCode.reason };
          }
          return {
            success: true,
            value: {
              address1: parsed_address1.value,
              address2: parsed_address2.value,
              addressId: parsed_addressId.value,
              company: parsed_company.value,
              countryCode: parsed_countryCode.value,
              department: parsed_department.value,
              firstName: parsed_firstName.value,
              lastName: parsed_lastName.value,
              phone: parsed_phone.value,
              position: parsed_position.value,
              state: parsed_state.value,
              title: parsed_title.value,
              town: parsed_town.value,
              vat: parsed_vat.value,
              zipCode: parsed_zipCode.value,
            },
          };
        })(value);
      })(value["billingAddress"]);
    })();
    if (!parsed_billingAddress.success) {
      return { success: false, reason: parsed_billingAddress.reason };
    }
    if (!hasProp(value, "careerLevel")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/careerLevel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'careerLevel'.` };
    }
    const parsed_careerLevel = ((): ParserResult<CareerLevel | null> => {
      return ((value: unknown): ParserResult<CareerLevel | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return ((
          value: unknown,
        ): ParserResult<
          | "OWNER_EXECUTIVE_C_LEVEL"
          | "SENIOR_MANAGEMENT"
          | "MIDDLE_MANAGEMENT"
          | "JUNIOR_MANAGEMENT"
          | "ADMINISTRATIVE_STAFF"
          | "EMPLOYEE_WITHOUT_MANAGEMENT_OR_LEADERSHIP_RESPONSIBILITY"
          | "STUDENT_OR_TRAINEE"
          | "TEACHER_OR_ACADEMIC"
          | "NOT_EMPLOYED"
          | "RETIRED"
          | "OTHER"
          | "UNDEFINED"
        > => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/CareerLevel]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "OWNER_EXECUTIVE_C_LEVEL":
              return { success: true, value: "OWNER_EXECUTIVE_C_LEVEL" };
            case "SENIOR_MANAGEMENT":
              return { success: true, value: "SENIOR_MANAGEMENT" };
            case "MIDDLE_MANAGEMENT":
              return { success: true, value: "MIDDLE_MANAGEMENT" };
            case "JUNIOR_MANAGEMENT":
              return { success: true, value: "JUNIOR_MANAGEMENT" };
            case "ADMINISTRATIVE_STAFF":
              return { success: true, value: "ADMINISTRATIVE_STAFF" };
            case "EMPLOYEE_WITHOUT_MANAGEMENT_OR_LEADERSHIP_RESPONSIBILITY":
              return { success: true, value: "EMPLOYEE_WITHOUT_MANAGEMENT_OR_LEADERSHIP_RESPONSIBILITY" };
            case "STUDENT_OR_TRAINEE":
              return { success: true, value: "STUDENT_OR_TRAINEE" };
            case "TEACHER_OR_ACADEMIC":
              return { success: true, value: "TEACHER_OR_ACADEMIC" };
            case "NOT_EMPLOYED":
              return { success: true, value: "NOT_EMPLOYED" };
            case "RETIRED":
              return { success: true, value: "RETIRED" };
            case "OTHER":
              return { success: true, value: "OTHER" };
            case "UNDEFINED":
              return { success: true, value: "UNDEFINED" };
            default:
              return {
                success: false,
                reason: `[#/components/schemas/CareerLevel]: '${value}' expected to be enum, one of 'OWNER_EXECUTIVE_C_LEVEL, SENIOR_MANAGEMENT, MIDDLE_MANAGEMENT, JUNIOR_MANAGEMENT, ADMINISTRATIVE_STAFF, EMPLOYEE_WITHOUT_MANAGEMENT_OR_LEADERSHIP_RESPONSIBILITY, STUDENT_OR_TRAINEE, TEACHER_OR_ACADEMIC, NOT_EMPLOYED, RETIRED, OTHER, UNDEFINED'.`,
              };
          }
        })(value);
      })(value["careerLevel"]);
    })();
    if (!parsed_careerLevel.success) {
      return { success: false, reason: parsed_careerLevel.reason };
    }
    if (!hasProp(value, "changePassword")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/changePassword]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'changePassword'.` };
    }
    const parsed_changePassword = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/changePassword]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["changePassword"]);
    })();
    if (!parsed_changePassword.success) {
      return { success: false, reason: parsed_changePassword.reason };
    }
    if (!hasProp(value, "commentNotification")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/commentNotification]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'commentNotification'.` };
    }
    const parsed_commentNotification = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/commentNotification]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["commentNotification"]);
    })();
    if (!parsed_commentNotification.success) {
      return { success: false, reason: parsed_commentNotification.reason };
    }
    if (!hasProp(value, "customGender")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/customGender]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customGender'.` };
    }
    const parsed_customGender = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/customGender]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["customGender"]);
    })();
    if (!parsed_customGender.success) {
      return { success: false, reason: parsed_customGender.reason };
    }
    if (!hasProp(value, "customerId")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
    }
    const parsed_customerId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/customerId]: '${value}' expected to be of type number.` };
      })(value["customerId"]);
    })();
    if (!parsed_customerId.success) {
      return { success: false, reason: parsed_customerId.reason };
    }
    if (!hasProp(value, "education")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/education]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'education'.` };
    }
    const parsed_education = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/education]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["education"]);
    })();
    if (!parsed_education.success) {
      return { success: false, reason: parsed_education.reason };
    }
    if (!hasProp(value, "email")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/email]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'email'.` };
    }
    const parsed_email = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/email]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["email"]);
    })();
    if (!parsed_email.success) {
      return { success: false, reason: parsed_email.reason };
    }
    if (!hasProp(value, "gender")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/gender]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'gender'.` };
    }
    const parsed_gender = ((): ParserResult<Gender | null> => {
      return ((value: unknown): ParserResult<Gender | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return ((value: unknown): ParserResult<"FEMALE" | "MALE" | "UNKNOWN" | "CUSTOM"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/Gender]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "FEMALE":
              return { success: true, value: "FEMALE" };
            case "MALE":
              return { success: true, value: "MALE" };
            case "UNKNOWN":
              return { success: true, value: "UNKNOWN" };
            case "CUSTOM":
              return { success: true, value: "CUSTOM" };
            default:
              return { success: false, reason: `[#/components/schemas/Gender]: '${value}' expected to be enum, one of 'FEMALE, MALE, UNKNOWN, CUSTOM'.` };
          }
        })(value);
      })(value["gender"]);
    })();
    if (!parsed_gender.success) {
      return { success: false, reason: parsed_gender.reason };
    }
    if (!hasProp(value, "htmlEmail")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/htmlEmail]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'htmlEmail'.` };
    }
    const parsed_htmlEmail = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/htmlEmail]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["htmlEmail"]);
    })();
    if (!parsed_htmlEmail.success) {
      return { success: false, reason: parsed_htmlEmail.reason };
    }
    if (!hasProp(value, "invoiceByPost")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/invoiceByPost]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'invoiceByPost'.` };
    }
    const parsed_invoiceByPost = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/invoiceByPost]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["invoiceByPost"]);
    })();
    if (!parsed_invoiceByPost.success) {
      return { success: false, reason: parsed_invoiceByPost.reason };
    }
    if (!hasProp(value, "language")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
    }
    const parsed_language = ((): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
      return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/language]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "en":
            return { success: true, value: "en" };
          case "de":
            return { success: true, value: "de" };
          case "es":
            return { success: true, value: "es" };
          case "ru":
            return { success: true, value: "ru" };
          case "zh":
            return { success: true, value: "zh" };
          case "pt":
            return { success: true, value: "pt" };
          case "fr":
            return { success: true, value: "fr" };
          default:
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
        }
      })(value["language"]);
    })();
    if (!parsed_language.success) {
      return { success: false, reason: parsed_language.reason };
    }
    if (!hasProp(value, "mailAddress")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/mailAddress]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mailAddress'.` };
    }
    const parsed_mailAddress = ((): ParserResult<CustomerAdminDetailAddress> => {
      return ((value: unknown): ParserResult<CustomerAdminDetailAddress> => {
        return ((
          value: unknown,
        ): ParserResult<{
          address1: string | null;
          address2: string | null;
          addressId: number;
          company: string | null;
          countryCode: string | null;
          department: string | null;
          firstName: string | null;
          lastName: string | null;
          phone: string | null;
          position: string | null;
          state: string | null;
          title: number;
          town: string | null;
          vat: string | null;
          zipCode: string | null;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "address1")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/address1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'address1'.` };
          }
          const parsed_address1 = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/address1]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["address1"]);
          })();
          if (!parsed_address1.success) {
            return { success: false, reason: parsed_address1.reason };
          }
          if (!hasProp(value, "address2")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/address2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'address2'.` };
          }
          const parsed_address2 = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/address2]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["address2"]);
          })();
          if (!parsed_address2.success) {
            return { success: false, reason: parsed_address2.reason };
          }
          if (!hasProp(value, "addressId")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/addressId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'addressId'.` };
          }
          const parsed_addressId = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/addressId]: '${value}' expected to be of type number.` };
            })(value["addressId"]);
          })();
          if (!parsed_addressId.success) {
            return { success: false, reason: parsed_addressId.reason };
          }
          if (!hasProp(value, "company")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/company]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'company'.` };
          }
          const parsed_company = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/company]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["company"]);
          })();
          if (!parsed_company.success) {
            return { success: false, reason: parsed_company.reason };
          }
          if (!hasProp(value, "countryCode")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/countryCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryCode'.` };
          }
          const parsed_countryCode = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/countryCode]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["countryCode"]);
          })();
          if (!parsed_countryCode.success) {
            return { success: false, reason: parsed_countryCode.reason };
          }
          if (!hasProp(value, "department")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/department]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'department'.` };
          }
          const parsed_department = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/department]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["department"]);
          })();
          if (!parsed_department.success) {
            return { success: false, reason: parsed_department.reason };
          }
          if (!hasProp(value, "firstName")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
          }
          const parsed_firstName = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/firstName]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["firstName"]);
          })();
          if (!parsed_firstName.success) {
            return { success: false, reason: parsed_firstName.reason };
          }
          if (!hasProp(value, "lastName")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
          }
          const parsed_lastName = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/lastName]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["lastName"]);
          })();
          if (!parsed_lastName.success) {
            return { success: false, reason: parsed_lastName.reason };
          }
          if (!hasProp(value, "phone")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/phone]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'phone'.` };
          }
          const parsed_phone = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/phone]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["phone"]);
          })();
          if (!parsed_phone.success) {
            return { success: false, reason: parsed_phone.reason };
          }
          if (!hasProp(value, "position")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/position]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'position'.` };
          }
          const parsed_position = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/position]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["position"]);
          })();
          if (!parsed_position.success) {
            return { success: false, reason: parsed_position.reason };
          }
          if (!hasProp(value, "state")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/state]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'state'.` };
          }
          const parsed_state = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/state]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["state"]);
          })();
          if (!parsed_state.success) {
            return { success: false, reason: parsed_state.reason };
          }
          if (!hasProp(value, "title")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
          }
          const parsed_title = ((): ParserResult<number> => {
            return ((value: unknown): ParserResult<number> => {
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/title]: '${value}' expected to be of type number.` };
            })(value["title"]);
          })();
          if (!parsed_title.success) {
            return { success: false, reason: parsed_title.reason };
          }
          if (!hasProp(value, "town")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/town]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'town'.` };
          }
          const parsed_town = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/town]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["town"]);
          })();
          if (!parsed_town.success) {
            return { success: false, reason: parsed_town.reason };
          }
          if (!hasProp(value, "vat")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/vat]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'vat'.` };
          }
          const parsed_vat = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/vat]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["vat"]);
          })();
          if (!parsed_vat.success) {
            return { success: false, reason: parsed_vat.reason };
          }
          if (!hasProp(value, "zipCode")) {
            return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/zipCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'zipCode'.` };
          }
          const parsed_zipCode = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/CustomerAdminDetailAddress/zipCode]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["zipCode"]);
          })();
          if (!parsed_zipCode.success) {
            return { success: false, reason: parsed_zipCode.reason };
          }
          return {
            success: true,
            value: {
              address1: parsed_address1.value,
              address2: parsed_address2.value,
              addressId: parsed_addressId.value,
              company: parsed_company.value,
              countryCode: parsed_countryCode.value,
              department: parsed_department.value,
              firstName: parsed_firstName.value,
              lastName: parsed_lastName.value,
              phone: parsed_phone.value,
              position: parsed_position.value,
              state: parsed_state.value,
              title: parsed_title.value,
              town: parsed_town.value,
              vat: parsed_vat.value,
              zipCode: parsed_zipCode.value,
            },
          };
        })(value);
      })(value["mailAddress"]);
    })();
    if (!parsed_mailAddress.success) {
      return { success: false, reason: parsed_mailAddress.reason };
    }
    if (!hasProp(value, "password")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/password]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'password'.` };
    }
    const parsed_password = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/password]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["password"]);
    })();
    if (!parsed_password.success) {
      return { success: false, reason: parsed_password.reason };
    }
    if (!hasProp(value, "pushFrequency")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/pushFrequency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'pushFrequency'.` };
    }
    const parsed_pushFrequency = ((): ParserResult<PushFrequency> => {
      return ((value: unknown): ParserResult<PushFrequency> => {
        return ((value: unknown): ParserResult<"NONE" | "DAILY" | "ONCE_A_WEEK" | "TWICE_A_MONTH" | "ONCE_A_MONTH"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/PushFrequency]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "NONE":
              return { success: true, value: "NONE" };
            case "DAILY":
              return { success: true, value: "DAILY" };
            case "ONCE_A_WEEK":
              return { success: true, value: "ONCE_A_WEEK" };
            case "TWICE_A_MONTH":
              return { success: true, value: "TWICE_A_MONTH" };
            case "ONCE_A_MONTH":
              return { success: true, value: "ONCE_A_MONTH" };
            default:
              return { success: false, reason: `[#/components/schemas/PushFrequency]: '${value}' expected to be enum, one of 'NONE, DAILY, ONCE_A_WEEK, TWICE_A_MONTH, ONCE_A_MONTH'.` };
          }
        })(value);
      })(value["pushFrequency"]);
    })();
    if (!parsed_pushFrequency.success) {
      return { success: false, reason: parsed_pushFrequency.reason };
    }
    if (!hasProp(value, "receiveNewsletters")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/receiveNewsletters]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'receiveNewsletters'.` };
    }
    const parsed_receiveNewsletters = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/receiveNewsletters]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["receiveNewsletters"]);
    })();
    if (!parsed_receiveNewsletters.success) {
      return { success: false, reason: parsed_receiveNewsletters.reason };
    }
    if (!hasProp(value, "unlimitedAccess")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/unlimitedAccess]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'unlimitedAccess'.` };
    }
    const parsed_unlimitedAccess = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/unlimitedAccess]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["unlimitedAccess"]);
    })();
    if (!parsed_unlimitedAccess.success) {
      return { success: false, reason: parsed_unlimitedAccess.reason };
    }
    if (!hasProp(value, "yearOfBirth")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/yearOfBirth]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'yearOfBirth'.` };
    }
    const parsed_yearOfBirth = ((): ParserResult<number | null> => {
      return ((value: unknown): ParserResult<number | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/CustomerAdminDetailForm/yearOfBirth]: '${value}' expected to be of type number.` };
      })(value["yearOfBirth"]);
    })();
    if (!parsed_yearOfBirth.success) {
      return { success: false, reason: parsed_yearOfBirth.reason };
    }
    return {
      success: true,
      value: {
        areaOfExpertise: parsed_areaOfExpertise.value,
        batchEmails: parsed_batchEmails.value,
        billingAddress: parsed_billingAddress.value,
        careerLevel: parsed_careerLevel.value,
        changePassword: parsed_changePassword.value,
        commentNotification: parsed_commentNotification.value,
        customGender: parsed_customGender.value,
        customerId: parsed_customerId.value,
        education: parsed_education.value,
        email: parsed_email.value,
        gender: parsed_gender.value,
        htmlEmail: parsed_htmlEmail.value,
        invoiceByPost: parsed_invoiceByPost.value,
        language: parsed_language.value,
        mailAddress: parsed_mailAddress.value,
        password: parsed_password.value,
        pushFrequency: parsed_pushFrequency.value,
        receiveNewsletters: parsed_receiveNewsletters.value,
        unlimitedAccess: parsed_unlimitedAccess.value,
        yearOfBirth: parsed_yearOfBirth.value,
      },
    };
  })(parseJsonWithNumbersAsBigint(str));
}
